import React from 'react'
import { useRecoilState } from 'recoil'
import { Colors } from 'src/components/theme'
import { authData } from 'src/components/auth/util'
import { logEvent } from 'src/components/analytics'

import * as mapAtoms from 'src/atoms/main-map'
import { IconActionButton } from 'src/v2/components/copy-button'

type Props = {
  color?: string
}

export const StreetViewIcon: React.FC<Props> = ({ color = Colors.blueDark }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={18} fill="none">
    <path
      fill={color}
      d="M16 15.093c0 .477-.233.907-.699 1.29-.466.382-1.087.689-1.864.92-.776.231-1.628.405-2.556.523-.928.117-1.889.176-2.881.176-.992 0-1.953-.059-2.88-.176a16.022 16.022 0 0 1-2.558-.523c-.776-.231-1.397-.538-1.863-.92C.233 16 0 15.57 0 15.093c0-.371.125-.707.375-1.006.25-.3.595-.551 1.034-.756a9.44 9.44 0 0 1 1.341-.505c.455-.133.95-.245 1.489-.336a.687.687 0 0 1 .545.12.684.684 0 0 1 .296.471.687.687 0 0 1-.12.546.684.684 0 0 1-.471.295c-.44.076-.841.165-1.205.267a7.674 7.674 0 0 0-.87.29c-.215.091-.399.18-.55.267a1.433 1.433 0 0 0-.313.222.392.392 0 0 0-.096.136c.022.083.125.184.306.301.182.118.459.243.83.375.371.133.803.256 1.295.37.493.113 1.1.208 1.824.284.724.075 1.487.113 2.29.113.803 0 1.566-.038 2.29-.113a15.46 15.46 0 0 0 1.824-.285c.492-.113.924-.238 1.295-.375.371-.136.648-.263.83-.38.181-.118.284-.222.306-.313-.007-.03-.04-.072-.096-.125a2.051 2.051 0 0 0-.313-.216 3.963 3.963 0 0 0-.55-.267 8.75 8.75 0 0 0-.87-.284 11.987 11.987 0 0 0-1.205-.267.683.683 0 0 1-.471-.295.686.686 0 0 1-.12-.546.684.684 0 0 1 .296-.471.687.687 0 0 1 .545-.12c.538.091 1.035.203 1.489.336.454.132.902.3 1.34.505.44.205.785.457 1.035.756.25.3.375.635.375 1.006Z"
    />
    <path
      fill={color}
      d="M7.967 5.452c.366 0 .728-.07 1.067-.207.338-.138.645-.339.904-.592.26-.254.464-.555.605-.886.14-.331.212-.686.212-1.044C10.755 1.223 9.506 0 7.967 0A2.81 2.81 0 0 0 6 .797a2.694 2.694 0 0 0-.815 1.926c0 1.507 1.241 2.73 2.78 2.73ZM5.983 8.227s-.835 2.228-1.072 2.648c-.085.158-.07.203-.276.203-.207 0-.529-.203-.529-.203s-.153-.098-.092-.27c.184-.555 1.02-3.795 1.195-4.418.192-.667.713-.644.713-.644h.498L8.028 8.28l1.616-2.737h.598s.237.03.413.232c.184.202.222.555.222.555l1.065 4.05s.077.285.054.367c-.03.128-.1.128-.1.128s-.299.09-.467.143c-.306.097-.36-.188-.36-.188l-.996-2.55L9.958 15H8.465l-.253-3.832s-.046-.098-.184-.098a.195.195 0 0 0-.176.098L7.584 15H6.09l-.1-6.773h-.007Z"
    />
  </svg>
)

export const MiniStreetViewIcon = () => {
  const [streetView, setStreetView] = useRecoilState(mapAtoms.streetView)
  const onToggleStreetView = () => {
    if (!authData) {
      return
    }
    logEvent('street-view-toggle')
    setStreetView((streetView) => !streetView)
  }

  return (
    <IconActionButton active={streetView ? 1 : 0} ghost={1} size="small" onClick={onToggleStreetView}>
      <StreetViewIcon color={streetView ? 'white' : Colors.neutral400} />
    </IconActionButton>
  )
}
